import api from '@/services/api'
import type {
  AutoTradeTrigger,
  AutoTradeTriggerCreate,
  AutoTradeTriggerUpdate,
} from './types'

export const AutoTradeTriggerService = {
  fetchTriggers() {
    return api.get<AutoTradeTrigger[]>('/v2/auto-trade-triggers')
  },
  createTrigger(data: AutoTradeTriggerCreate) {
    return api.post<AutoTradeTrigger>('/v2/auto-trade-triggers', data)
  },
  updateTrigger(id: number, data: AutoTradeTriggerUpdate) {
    return api.put<AutoTradeTrigger>(`/v2/auto-trade-triggers/${id}`, data)
  },
  deleteTrigger(id: number) {
    return api.delete(`/v2/auto-trade-triggers/${id}`)
  },
  toggleTrigger(id: number) {
    return api.post<AutoTradeTrigger>(`/v2/auto-trade-triggers/${id}/toggle`)
  },
  toggleOneShot(id: number) {
    return api.post<AutoTradeTrigger>(`/v2/auto-trade-triggers/${id}/toggle-one-shot`)
  },
  resetFailed(id: number) {
    return api.post<AutoTradeTrigger>(`/v2/auto-trade-triggers/${id}/reset-failed`)
  },
}
